import { useApiQuery } from '@/api/main/query'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { RequisitVerificationProfile } from '@/entities/requisit/model'


export interface RequisitVerificationProfileListResultR {
  items: RequisitVerificationProfile[];
  totalCount: number;
  pageSize: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface RequisitVerificationsListParams {
  requisitId?: string;
  paymentRequestId?: string;
  isPassed?: boolean;
  dateFrom?: string;
  dateTo?: string;
  skip?: number;
  take?: number;
}

export function useRequisitVerificationsListQuery(params: RequisitVerificationsListParams = {}) {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const shouldFetch = userRole === Roles.Trader

  // Приводим параметры к нужному типу
  const queryParams: Record<string, string | number | boolean | undefined> = {
    ...params,
  }

  const queryKey = ['requisit-verifications-list', userRole, params]

  const query = useApiQuery<RequisitVerificationProfileListResultR>(
    queryKey,
    '/v1/trader/requisit-verifications/list',
    queryParams,
    {
      enabled: shouldFetch,
      staleTime:10,
    }
  )

  return {
    ...query,
    requisitVerificationsData: query.data,
    requisitVerificationsError: query.error,
    requisitVerificationsIsLoading: query.isLoading,
    isTrader: shouldFetch,
    queryKey,
  }
}